import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import SEO from "@/components/SEO";
import { KineticText } from "@/components/KineticText";
import Reveal from "@/components/Reveal";
import EditorialMarquee from "@/components/EditorialMarquee";
import { SERVICES } from "@/lib/content";

export default function Services() {
  return (
    <>
      <SEO
        title="Services"
        description="Wholesale vegetable supply, commission agent services, bulk orders, export supply, market-rate assistance, transparent trading and loading & transportation coordination from Karnavati Market Yard."
        path="services"
      />

      <section className="relative bg-brand-forest text-brand-bone pt-40 pb-24 md:pt-52 md:pb-32 grain overflow-hidden">
        <div className="max-w-screen-2xl mx-auto px-6 md:px-12 relative z-10">
          <span className="font-mono text-xs uppercase tracking-[0.28em] text-brand-leaf-light">What we do</span>
          <KineticText
            as="h1"
            lines={["Supply you can", "build a business on."]}
            className="font-display text-5xl md:text-8xl mt-6 leading-[0.92] tracking-tight"
          />
          <p className="mt-8 max-w-2xl text-brand-bone/70 text-lg leading-relaxed">
            From daily wholesale supply to full commission trading, bulk fulfilment and logistics — we handle the
            details so your kitchen, shop or export line never runs short.
          </p>
        </div>
      </section>

      <EditorialMarquee />

      <section className="py-20 md:py-28 max-w-screen-2xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-px bg-brand-forest/10 rounded-3xl overflow-hidden border border-brand-forest/10">
          {SERVICES.map((s, i) => (
            <Reveal key={s.n} delay={(i % 2) * 0.08} className="bg-brand-bone">
              <div className="group p-8 md:p-12 h-full hover:bg-white transition-colors duration-500">
                <div className="flex items-start justify-between">
                  <span className="font-mono text-brand-terra">{s.n}</span>
                  <ArrowUpRight size={22} className="text-brand-forest/30 group-hover:text-brand-leaf group-hover:-translate-y-1 group-hover:translate-x-1 transition-all duration-300" />
                </div>
                <h2 className="font-display text-3xl md:text-4xl text-brand-forest mt-6 tracking-tight leading-none">{s.title}</h2>
                <p className="mt-4 text-brand-muted leading-relaxed">{s.desc}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-24 max-w-screen-2xl mx-auto px-6 md:px-12">
        <div className="rounded-[2.5rem] bg-brand-sand p-10 md:p-16 flex flex-col md:flex-row md:items-center justify-between gap-8 grain relative overflow-hidden">
          <h2 className="font-display text-3xl md:text-5xl text-brand-forest tracking-tight max-w-xl relative z-10">
            Tell us what you need — we&apos;ll quote you fast.
          </h2>
          <Link to="/contact" data-testid="services-cta" className="relative z-10 inline-flex items-center gap-2 rounded-full bg-brand-forest text-brand-bone px-8 py-4 font-medium hover:bg-brand-forest-light transition-colors duration-300 active:scale-95 w-fit">
            Send an Enquiry <ArrowUpRight size={18} />
          </Link>
        </div>
      </section>
    </>
  );
}
